<div class="row align-items-center mb-3">
  <div class="col">
    <h5>ค้นหา</h5>
  </div>
  <div class="col-auto">
    <div>
      <button *ngIf="downloadExcel"  class="btn btn-dv" style="width: 113px;" (click)="excel.emit()">
        <i *ngIf="loading === true" class="fa fa-spinner fa-spin m-r-5"></i>
        <img *ngIf="loading === false" src="assets/images/excel.png" style="width:20px; height: 20px">
        ดาวน์โหลด
      </button>
      <button class="btn btn-dv btn-clean btn-wide mx-2" (click)="clear.emit()">
        <i class="fa fa-times m-r-5"></i>
        ล้างการค้นหา
      </button>
      <button class="btn btn-dv" style="width: 100px;" (click)="search.emit()">
        <i *ngIf="loading === true" class="fa fa-spinner fa-spin m-r-5"></i>
        <i *ngIf="loading === false" class="fa fa-search m-r-5"></i>
        ค้นหา
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/core/filter-header/filter-header.component.html